module.exports = __webpack_public_path__ + "img/portal.1f3bd4a6.png";